// src/App.js
import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Topbar      from "./components/Topbar";
import Footer      from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Landing     from "./pages/Landing";
import Datenschutz from "./pages/Datenschutz";
import Impressum   from "./pages/Impressum";
import BlogIndex   from "./pages/blog";
import BlogPost    from "./pages/blog/[slug]";
import EdifactFormatter from "./pages/EdifactFormatter";
import Validator from "./pages/Validator";
import NotFound from "./pages/NotFound";

// Glossar
import GlossarIndex from "./pages/glossar";
import GlossarDetail from "./pages/glossar/GlossarDetail";

// ✨ NEU:  Template + Daten für die Landing-Pages
import ConverterLanding from "./pages/ConverterLanding";
import landingPageData  from "./data/landingPages.json";

// Konverter & Viewer laden Excel-/PDF-Bibliotheken (~450 KB) – nur bei Bedarf nachladen
const Tool   = lazy(() => import("./pages/Tool"));
const Viewer = lazy(() => import("./pages/Viewer"));

const PageLoading = () => (
  <div className="section container row row-center" aria-busy="true">
    <span className="spinner" aria-hidden="true" />
  </div>
);

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="app-shell">
        <Topbar />

        <main className="app-main">
          <Suspense fallback={<PageLoading />}>
          <Routes>
            {/* bestehende Seiten */}
            <Route path="/"            element={<Landing />} />
            <Route path="/edi-konverter"        element={<Tool />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/impressum"   element={<Impressum />} />
            <Route path="/blog"        element={<BlogIndex />} />
            <Route path="/blog/:slug"  element={<BlogPost />} />
            <Route path="/edifact-viewer" element={<Viewer />} />
            <Route path="/edifact-formatter" element={<EdifactFormatter />} />
            <Route path="/edifact-validator" element={<Validator />} />

            {/* EDIFACT Glossar */}
            <Route path="/glossar"       element={<GlossarIndex />} />
            <Route path="/glossar/:term" element={<GlossarDetail />} />

            {/* SEO-Landing-Pages – werden automatisch aus JSON generiert */}
            {landingPageData.map(p => (
              <Route
                key={p.slug}
                path={`/${p.slug}`}
                element={<ConverterLanding data={p} />}
              />
            ))}

            {/* Unbekannte Pfade: 404-Seite mit noindex (statt Startseiten-Duplikat) */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          </Suspense>
        </main>

        <Footer />
      </div>
    </Router>
  );
}
